import {FC, useEffect, useState} from 'react'
import {ProfessionalOverviewTab} from '../../biography/components/tabs/ProfessionalOverviewTab'
import {LifestyleTab} from '../../biography/components/tabs/LifestyleTab'
import {RecognitionTab} from '../../biography/components/tabs/RecognitionTab'
import {ExpertiseTab} from '../../biography/components/tabs/ExpertiseTab'
import {ProfileMemberInfoAdmin} from './ProfileMemberInfoAdmin'
import {ProfileMemberInfoFamily} from './ProfileMemberInfoFamily'
import {Link, useHistory, useLocation} from 'react-router-dom'
import {KTSVG} from '../../../../_metronic/helpers'
import {BiographyTab} from '../../biography/components/tabs/BiographyTab'
import MemberCategoriesAdmin from '../../members/components/MemberCategoriesAdmin'

interface ProfileMemberTabsSectionProps {}

export const ProfileMemberTabsSection: FC<ProfileMemberTabsSectionProps> = () => {
  const [activeTab, setActiveTab] = useState('biography')
  const history = useHistory()
  const location = useLocation()

  // PR-I-85: Expertise vuelve al perfil admin/staff del member (revierte parte de PR-I-80).
  // El boton EDIT desde aca sigue apuntando a /expertise (pagina admin) porque este componente
  // se usa desde la ficha staff; el flujo member propio edita via /profile/edit-expertise.
  const tabs = [
    {id: 'biography', label: 'Biography'},
    {id: 'professional', label: 'Professional Overview'},
    {id: 'lifestyle', label: 'Lifestyle'},
    {id: 'recognition', label: 'Recognition'},
    {id: 'expertise', label: 'Expertise'},
    {id: 'categories', label: 'Categories'},
    // {id: 'general', label: 'confidential'},
  ]

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const option = params.get('option')
    if (option) {
      setActiveTab(option)
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth',
        })
      }, 800)
    } else {
      onHandleSelectTab('biography')
    }
  }, [])

  const onHandleSelectTab = (tabId: string) => {
    const params = new URLSearchParams(location.search)
    params.set('option', tabId)
    history.push({
      pathname: location.pathname,
      search: params.toString(),
    })
    setTimeout(() => {
      setActiveTab(tabId)
    }, 100)
  }

  return (
    <div className='nb-pm-tabs-section'>
      <div className='nb-pm-tabs-header'>
        <div className='nb-pm-tabs-row'>
          <div className='nb-pm-tabs-list'>
            {tabs.map((tab, index) => (
              <div className='tap-flex-center' key={tab.id}>
                <div
                  className={`nb-pm-tabs-item ${
                    activeTab === tab.id ? 'nb-pm-tabs-item--active' : ''
                  }`}
                  onClick={() => onHandleSelectTab(tab.id)}
                >
                  <div className='nb-pm-tabs-item-text'>{tab.label}</div>
                </div>
                {index < tabs.length - 1 && (
                  <svg
                    className='ml_3'
                    width='1'
                    height='20'
                    viewBox='0 0 1 20'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path d='M0.5 0V20' stroke='#B4B4B4' />
                  </svg>
                )}
              </div>
            ))}
          </div>

          <div className='nb-pm-confidential-btn' onClick={() => onHandleSelectTab('general')}>
            <div className='nb-pm-confidential-btn-text'>Confidential Info</div>
          </div>
        </div>

        <div className='nb-pm-edit-row'>
          <button
            className='nb-pm-edit-btn'
            onClick={() => {
              const routes: Record<string, string> = {
                biography: '/biography/overview',
                professional: '/admin/overview/professional',
                lifestyle: '/admin/overview/personal',
                recognition: '/recognition',
                expertise: '/expertise',
                categories: '/admin/overview/categories',
                general: '/admin/overview/confidential',
              }

              const route = routes[activeTab] || '/profile-member'
              history.push(route)
            }}
          >
            <span className='nb-pm-edit-btn-text'>EDIT</span>
            <KTSVG path='/media/svg/nobilis/vector1.svg' className='nb-pm-edit-btn-icon' />
          </button>
        </div>
      </div>

      {/* Contenido de cada tab */}
      <div className='nb-pm-tabs-content'>
        {activeTab === 'biography' && <BiographyTab />}
        {activeTab === 'professional' && <ProfessionalOverviewTab />}
        {activeTab === 'lifestyle' && <LifestyleTab />}
        {activeTab === 'recognition' && <RecognitionTab />}
        {activeTab === 'expertise' && <ExpertiseTab />}
        {activeTab === 'categories' && <MemberCategoriesAdmin />}
        {activeTab === 'general' && (
          <div className='nb-pm-tabs-panel--two-col'>
            <ProfileMemberInfoAdmin />
            <ProfileMemberInfoFamily />
          </div>
        )}
      </div>
    </div>
  )
}
